// source: pbtypes/gen/body/gps_origin.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector2d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector2d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector2d_pb);
goog.exportSymbol('proto.body.GpsOrigin', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.body.GpsOrigin = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.body.GpsOrigin, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.body.GpsOrigin.displayName = 'proto.body.GpsOrigin';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.body.GpsOrigin.prototype.toObject = function(opt_includeInstance) {
  return proto.body.GpsOrigin.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.body.GpsOrigin} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.body.GpsOrigin.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
latLon: (f = msg.getLatLon()) && pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.toObject(includeInstance, f),
altitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.body.GpsOrigin}
 */
proto.body.GpsOrigin.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.body.GpsOrigin;
  return proto.body.GpsOrigin.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.body.GpsOrigin} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.body.GpsOrigin}
 */
proto.body.GpsOrigin.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = new pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.deserializeBinaryFromReader);
      msg.setLatLon(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAltitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.body.GpsOrigin.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.body.GpsOrigin.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.body.GpsOrigin} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.body.GpsOrigin.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getLatLon();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.serializeBinaryToWriter
    );
  }
  f = message.getAltitude();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.body.GpsOrigin.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.body.GpsOrigin} returns this
 */
proto.body.GpsOrigin.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional eigen_lcm.Vector2dPb lat_lon = 2;
 * @return {?proto.eigen_lcm.Vector2dPb}
 */
proto.body.GpsOrigin.prototype.getLatLon = function() {
  return /** @type{?proto.eigen_lcm.Vector2dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb, 2));
};


/**
 * @param {?proto.eigen_lcm.Vector2dPb|undefined} value
 * @return {!proto.body.GpsOrigin} returns this
*/
proto.body.GpsOrigin.prototype.setLatLon = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.body.GpsOrigin} returns this
 */
proto.body.GpsOrigin.prototype.clearLatLon = function() {
  return this.setLatLon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.body.GpsOrigin.prototype.hasLatLon = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double altitude = 3;
 * @return {number}
 */
proto.body.GpsOrigin.prototype.getAltitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.body.GpsOrigin} returns this
 */
proto.body.GpsOrigin.prototype.setAltitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


goog.object.extend(exports, proto.body);
